import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Grid, MenuItem, Paper, TextField} from "@mui/material";
import TextFieldWithValidation from "../../../components/input/TextFieldWithValidation";
import {companyAccountsStore} from "../../../store/CompanyAccounts";
import BackupIcon from "@mui/icons-material/Backup";
import {getFileBase64} from "../../../utils/ReadFile";
import {statementApi} from "../../../backend/StatementApi";
import {useNavigate} from "react-router-dom";
import {routes} from "../../../main/Routes";
import CurrencySelector from "../../../components/CurrencySelector";

interface UploadStatementStripProps {
}

const UploadStatementStrip: React.FC<UploadStatementStripProps> = () => {
    const navigate = useNavigate();

    const [file, setFile] = useState<File | null>(null)
    const [iban, setIban] = useState<string>()
    const [currency, setCurrency] = useState<string>("")

    const [showUploadError, setShowUploadError] = useState(false)

    const isCsvFile = useMemo(() => (file?.name ?? "").toLocaleLowerCase().endsWith(".csv"), [file])

    useEffect(() => {
        setShowUploadError(false)
    }, [iban, currency])

    const uploadStatement = useCallback(async () => {
        if (isCsvFile && (!iban || !currency)) {
            setShowUploadError(true);
            return
        }
        if (file) {
            const fileAsBase64 = await getFileBase64(file);
            const statementId = await statementApi.uploadStatement(iban, currency, fileAsBase64);
            navigate(routes.singleStatement.replace(':id', statementId))
        }
    }, [isCsvFile, file, iban, currency, navigate]);


    return <Paper style={{marginTop: "0.5rem"}} elevation={8}>
        <Grid container>
            <Grid container item xs={10}>
                <Grid container>
                    <Grid container item xs={4} alignItems={"center"}>
                        <TextField type="file" onChange={({target}: any) => {
                            setFile(target.files[0])
                        }}/>
                    </Grid>
                    <Grid item xs={4}>
                        <TextFieldWithValidation
                                disabled={!isCsvFile}
                                select={true}
                                value={iban ?? 0}
                                onChange={e => setIban(e.target.value)}
                                label={iban ? "Account" : " "}
                                fullWidth={true}
                                hasError={showUploadError}
                                errorText="Account is mandatory">
                            <MenuItem value={0}>Account</MenuItem>
                            {
                                companyAccountsStore.bankAccounts.map(account => {
                                    return <MenuItem key={account.iban + account.accountCode}
                                                     value={account.iban}>{account.name} - {account.iban}</MenuItem>
                                })
                            }
                        </TextFieldWithValidation>
                    </Grid>

                    <Grid item xs={4}>
                        <CurrencySelector
                                fullWidth={true}
                                disabled={!isCsvFile}
                                label="Currency"
                                onChange={code => setCurrency(code)}
                                value={currency}
                                hasError={showUploadError}
                                errorText="Currency is mandatory"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item xs={2}>
                <Button
                        disabled={!file}
                        variant="contained"
                        color="primary"
                        startIcon={<BackupIcon/>}
                        style={{width: "100%", marginTop: "1rem"}}
                        onClick={uploadStatement}>Upload</Button>
            </Grid>
        </Grid>
    </Paper>
}

export default UploadStatementStrip

